<template>
  <div ref="gtableCrud" class="gtable-crud">
    <!-- 搜索模块-Start -->
    <c-search
      v-if="visible_search"
      :loading="searchLoading"
      :visible="option_searchVisible"
      :columns="searchColumns"
      class="gtable-searchBox"
      :form.sync="searchForm"
      :search-span="option.searchSpan"
      :is-enter-search="option_enterSearch"
      @searchReset="searchReset"
      @searchChange="searchChange"
    >
      <template v-for="item in searchSlotItems" :slot="item">
        <slot :name="item" />
      </template>
    </c-search>
    <!-- form弹窗 -->
    <template v-for="(item, key) in sidebarShow">
      <c-form
        :key="key"
        :container="option_drawerAppendToParent && $refs.gtableCrud"
        :visible.sync="sidebarShow[key]"
        :width="option_drawerWidth"
        :title="sidebarTitle(key)"
        :loading="formLoading"
        :data="tempRowData"
        :option="option"
        :page-key="key"
        :custom="!option_form"
        :z-index="option_drawerZIndex"
        @beforeClose="handleBeforeClose(key)"
        @submit="handleSubmit"
        @reset="handleReset"
      >
        <template :slot="`${key}Drawer`">
          <slot :name="`${key}Drawer`" :row="tempRowData" />
        </template>
        <template v-for="slotName in formSlotItems" :slot="slotName">
          <slot :name="slotName" :type="key" :row="tempRowData" />
        </template>
      </c-form>
    </template>

    <!-- modal弹窗 -->
    <template v-for="(item, key) in modalShow">
      <c-modal
        :key="key"
        :visible="modalShow[key]"
        :page-key="key"
        :columns="columns.filter((o) => !o.columnHide)"
        :selected-columns="selectedColumns"
        @close="modalShow[key] = false"
        @modelConfirm="handleModelConfirm(key, $event)"
      />
    </template>

    <!-- 表格-Start -->
    <b-card class="table-content gt-table-mcc">
      <div
        style="display: block;width: 200px;height: 30px;position: absolute;z-index: 100"
      >
        <slot name="headLeftAera" />
      </div>
      <transition name="zoom-fade">
        <vue-good-table
          v-if="optionChange"
          ref="gtable-crud"
          theme="my-theme"
          :columns="tableColumn"
          :rows="rows"
          :fixed-header="option_fixedHeader"
          :line-numbers="option_lineNumbers"
          :row-style-class="rowStyleClass"
          :max-height="`${option_maxHeight}px`"
          :is-loading.sync="loading"
          style-class="vgt-table"
          :pagination-options="{
            enabled: option_isPagination,
          }"
          :select-options="{
            enabled: option_selection,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }"
          @on-row-click="onRowClick"
          @on-row-dblclick="onRowDoubleClick"
          @on-cell-click="onCellClick"
          @on-row-mouseenter="onRowMouseover"
          @on-row-mouseleave="onRowMouseleave"
        >
          <!-- 自定义表格顶部插槽 -->
          <div slot="table-actions" style="padding:5px 0">
            <!-- 功能按钮 -->
            <div v-if="visible_header">
              <!-- 自定义headMenuLeft -->
              <slot name="headMenuLeft" />
              <!-- 新增 -->
              <my-tooltip :tooltip="i18n('btns.add')">
                <b-button
                  v-if="btns.add"
                  variant="primary"
                  class="btn ml-0-5 mr-0-5"
                  size="sm"
                  @click="handleBeforeOpen('add', form)"
                >
                  <feather-icon icon="PlusIcon" size="18" />
                </b-button>
              </my-tooltip>
              <!-- 删除 -->
              <my-tooltip :tooltip="i18n('btns.delete')">
                <b-button
                  v-if="btns.batchDel"
                  variant="danger"
                  class="btn ml-0-5 mr-0-5"
                  size="sm"
                  @click="modelPrompt('batchDelete')"
                >
                  <feather-icon icon="Trash2Icon" size="18" />
                </b-button>
              </my-tooltip>
              <!-- 上传 -->
              <my-tooltip :tooltip="i18n('btns.upload')">
                <b-button
                  v-if="btns.upload"
                  variant="warning"
                  class="btn ml-0-5 mr-0-5"
                  size="sm"
                  @click="handleUpLoad"
                >
                  <feather-icon icon="UploadIcon" size="18" />
                </b-button>
              </my-tooltip>
              <!-- 下载 -->
              <my-tooltip :tooltip="i18n('btns.download')">
                <b-button
                  v-if="btns.download"
                  variant="success"
                  class="btn ml-0-5 mr-0-5"
                  size="sm"
                  @click="handleDownLoad"
                >
                  <feather-icon icon="DownloadIcon" size="18" />
                </b-button>
              </my-tooltip>
              <!-- 显示列配置 -->
              <my-tooltip :tooltip="i18n('btns.showCol')">
                <b-button
                  v-if="btns.columnOption"
                  variant="info"
                  class="btn ml-0-5 mr-0-5"
                  size="sm"
                  @click="modelPrompt('columnOption')"
                >
                  <feather-icon icon="GridIcon" size="18" />
                </b-button>
              </my-tooltip>
              <!-- 刷新 -->
              <my-tooltip :tooltip="i18n('btns.refresh')">
                <b-button
                  v-if="btns.refresh"
                  variant="secondary"
                  class="btn ml-0-5 "
                  size="sm"
                  @click="handleRefresh"
                >
                  <feather-icon icon="RefreshCcwIcon" size="18" />
                </b-button>
              </my-tooltip>
              <!-- 自定义headMenu -->
              <slot name="headMenu" />
              <!-- 自定义headMenuRight -->
              <slot name="headMenuRight" />
            </div>
          </div>

          <!-- 自定义列标题-->
          <template slot="table-column" slot-scope="props">
            <slot name="table-column" :column="props.column" />
            <span
              v-if="props.column.field == '_menu'"
              class="text-left d-block"
              style="margin: 0 7px;"
            >
              <span>{{ props.column.label }}</span>
            </span>
          </template>
          <!-- 自定义列 -->
          <template slot="table-row" slot-scope="props">
            <slot name="table-row" :column="props.column" :row="props.row" />

            <!-- Column: Menu -->
            <span v-if="props.column.field === '_menu'">
              <div class="custom-col">
                <div
                  v-if="$scopedSlots.menuLeft"
                  class="menuSlot text-primary menu-slot"
                >
                  <slot name="menuLeft" :row="props.row" />
                </div>
                <span
                  v-if="
                    typeof btns.view === 'function'
                      ? btns.view(props.row)
                      : btns.view
                  "
                >
                  <my-tooltip :tooltip="i18n('btns.view')">
                    <feather-icon
                      icon="SearchIcon"
                      class="text-primary cursor-pointer"
                      size="20"
                      @click="handleBeforeOpen('view', props.row)"
                    />
                  </my-tooltip>
                </span>
                <span
                  v-if="
                    typeof btns.edit === 'function'
                      ? btns.edit(props.row)
                      : btns.edit
                  "
                >
                  <my-tooltip :tooltip="i18n('btns.edit')">
                    <feather-icon
                      icon="Edit2Icon"
                      class="text-warning cursor-pointer"
                      size="20"
                      @click="handleBeforeOpen('edit', props.row)"
                    />
                  </my-tooltip>
                </span>
                <span
                  v-if="
                    typeof btns.del === 'function'
                      ? btns.del(props.row)
                      : btns.del
                  "
                >
                  <my-tooltip :tooltip="i18n('btns.delete')">
                    <feather-icon
                      icon="Trash2Icon"
                      class="text-danger cursor-pointer"
                      size="20"
                      @click="modelPrompt('delete', props.row)"
                    />
                  </my-tooltip>
                </span>
                <div
                  v-if="$scopedSlots.menu"
                  class="menuSlot text-primary menu-slot"
                >
                  <slot name="menu" :row="props.row" />
                </div>
                <span v-if="$scopedSlots.menuOther" class="menuOtherIcon">
                  <a-dropdown
                    variant="link"
                    :trigger="['click']"
                    placement="bottomCenter"
                    overlay-class-name="gtable-crud__dropdown"
                  >
                    <template>
                      <my-tooltip :tooltip="i18n('btns.other')">
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="20"
                          class="text-body cursor-pointer"
                        />
                        <div
                          style="display: none;"
                          class="gtable-crud__dropdown-menuSlot"
                        >
                          <slot name="menuOther" :row="props.row" />
                        </div>
                      </my-tooltip>
                    </template>
                    <div slot="overlay" class="menuSlot">
                      <slot name="menuOther" :row="props.row" />
                    </div>
                  </a-dropdown>
                </span>
              </div>
            </span>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <c-pagination
              :page-options="pageOptions"
              :props="props"
              :page="page"
              @pageSizeChange="$emit('pageSizeChange', $event)"
              @pageChange="$emit('pageChange', $event)"
            />
          </template>
        </vue-good-table>
      </transition>
      <!-- slot-scope="props" -->
      <slot name="bottom" :row="props" />
    </b-card>
    <!-- 表格-End -->
  </div>
</template>

<script>
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table'
import { deepClone } from '@/util/util'
import { BButton, BCard } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// 自定义插件
import CForm from './form.vue'
import CModal from './modal.vue'
import CSearch from './search.vue'
import CPagination from './pagination.vue'

import MyTooltip from '../myTooltip.vue'

export default {
  components: {
    CForm,
    CModal,
    CSearch,
    MyTooltip,
    BButton,
    BCard,
    VueGoodTable,
    CPagination,
  },
  props: {
    // 配置
    /**
      option:{
        addBtn: true, 显示搜索(默认 true)
        search: false 显示搜索(默认 false)
        searchVisible: true 搜索默认展开(默认 true)
        fixedHeader: true  固定表头(默认 true)
        lineNumbers: false 显示每行数据的下标(默认 false)
        columns:[ 列
          label: 'Name', 显示列名
          field: 'name', 列对应data字段
        ]
      }
     * */
    option: {
      type: Object,
      default: () => ({}),
    },
    pageOptions: {
      type: Array,
      default: () => ['10', '20', '30', '50', '100'],
    },
    // 数据
    data: {
      type: Array,
      default: () => [],
    },
    form: {
      type: Object,
      default: () => {},
    },
    searchForm: {
      type: Object,
      default: () => {},
    },
    // 自定义行样式
    rowStyleClass: {
      type: [Function, String],
      default: null,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // 弹窗打开前的回调
    beforeOpen: {
      type: Function,
      default: (done) => {
        done()
      },
    },
    // 弹窗关闭前的回调
    beforeClose: {
      type: Function,
      default: (done) => {
        done()
      },
    },
    permission: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      columns: this.option.columns || [],
      searchLoading: false,
      formLoading: false,
      sidebarShow: {
        add: false,
        edit: false,
        view: false,
        // upload: false,
      },
      modalShow: {
        delete: false,
        batchDelete: false,
        columnOption: false,
      },
      // tempRowData: this.form || {},
      tempRowData: deepClone(this.form) || {},
      // queryData: deepClone(this.searchForm) || {},
      queryData: this.searchForm || {},
      selectedColumns: [],
      // 需要number转string的类型
      hasToStringTypes: ['select', 'date'],
      optionChange: true,
    }
  },
  computed: {
    // 回车搜索功能
    option_enterSearch() {
      return this.option.isEnterSearch !== false
    },
    option_searchVisible() {
      return this.option.searchVisible || false
    },
    //  #TODO 可能存在问题
    option_drawerWidth() {
      // return this.option.drawerWidth ? `${this.option.drawerWidth}px` : 'auto'
      return this.option.drawerWidth ? `${this.option.drawerWidth}px` : '500'
    },
    option_drawerZIndex() {
      return this.option.drawerZIndex
    },
    option_drawerAppendToParent() {
      return this.option.drawerAppendToParent || false
    },
    option_form() {
      return typeof this.option.form === 'boolean' ? this.option.form : true
    },
    searchColumns() {
      const temp = []
      this.columns.forEach((item) => {
        if (item.search) {
          temp.push(item)
        }
      })
      return temp
    },
    searchSlotItems() {
      const slots = this.searchColumns.filter((o) => o.searchSlot) || []
      return slots.map((o) => `${o.field}Search`)
    },
    formSlotItems() {
      const cols = this.option.columns || []
      const slots =
        cols.filter((o) => {
          if (o.formOption) {
            if (o.formOption.slot) return o
          }
          return false
        }) || []
      return slots.map((o) => `${o.field}Form`)
    },
    // 表格计算属性
    btns() {
      let addRes =
        typeof this.permission.addBtn === 'boolean'
          ? this.permission.addBtn
          : true
      let viewRes =
        typeof this.permission.viewBtn === 'boolean'
          ? this.permission.viewBtn
          : true
      let editRes =
        typeof this.permission.editBtn === 'boolean'
          ? this.permission.editBtn
          : true
      let delRes =
        typeof this.permission.delBtn === 'boolean'
          ? this.permission.delBtn
          : true
      if (['boolean'].indexOf(typeof this.option.addBtn) !== -1) {
        addRes = this.option.addBtn
      }
      if (['boolean', 'function'].indexOf(typeof this.option.viewBtn) !== -1) {
        viewRes = this.option.viewBtn
      }
      if (['boolean', 'function'].indexOf(typeof this.option.editBtn) !== -1) {
        editRes = this.option.editBtn
      }
      if (['boolean', 'function'].indexOf(typeof this.option.delBtn) !== -1) {
        delRes = this.option.delBtn
      }
      const res = {
        add: addRes,
        view: viewRes,
        edit: editRes,
        del: delRes,
        batchDel: this.option.batchDelBtn || false,
        upload: this.option.uploadBtn || false,
        download: this.option.downloadBtn || false,
        columnOption:
          typeof this.option.columnOption === 'boolean'
            ? this.option.columnOption
            : true,
        refresh:
          typeof this.option.refreshBtn === 'boolean'
            ? this.option.refreshBtn
            : true,
      }
      return res
    },
    uniqueColumns() {
      const temp = deepClone(this.columns)
      let result = []

      function unique(arr1) {
        const res = new Map()
        return arr1.filter((a) => !res.has(a.field) && res.set(a.field, 1))
      }
      result = unique(temp)
      return result
    },
    columnsFormat() {
      const result = this.uniqueColumns.filter((o) => !o.hide)
      return result
    },
    tableColumn() {
      const res = []
      this.columnsFormat.forEach((item) => {
        const t = item
        t.key = t.field
        if (item.dictField) {
          t.field = item.dictField
        }
        res.push(t)
      })
      return res
    },
    rows() {
      const data = []
      this.data.forEach((row) => {
        const temp = row
        this.option.columns.forEach((item) => {
          const type = item.formOption ? item.formOption.type : 'none'
          if (this.hasToStringTypes.indexOf(type) !== -1) {
            temp[item.field] = row[item.field] ? row[item.field].toString() : ''
          }
        })
        data.push(temp)
      })
      return data
    },
    option_fixedHeader() {
      return typeof this.option.fixedHeader === 'boolean'
        ? this.option.fixedHeader
        : true
    },
    option_lineNumbers() {
      return this.option.lineNumbers || false
    },
    option_maxHeight() {
      return this.option.maxHeight || false
    },
    option_menuWidth() {
      return this.option.menuWidth || 200
    },
    option_selection() {
      return this.option.selection || false
    },
    // 是否显示分页 isPagination
    option_isPagination() {
      return this.option.isPagination || true
    },
    option_menu() {
      return typeof this.option.menu === 'boolean' ? this.option.menu : true
    },
    visible_header() {
      return typeof this.option.header === 'boolean' ? this.option.header : true
    },
    option_addBtn() {
      return typeof this.option.addBtn === 'boolean' ? this.option.addBtn : true
    },
    visible_search() {
      return typeof this.option.search === 'boolean' ? this.option.search : true
    },
  },
  watch: {
    option: {
      handler(e) {
        this.columns = e.columns
        // 判断menu是否需要渲染
        if (this.option_menu) {
          this.columns.push({
            label: this.i18n('btns.menu'),
            field: '_menu',
            sortable: false,
            width: `${this.option_menuWidth}px`,
          })
        }
        if (!e.notHandler) {
          this.optionChange = false
          setTimeout(() => {
            this.optionChange = true
          }, 10)
        }
      },
    },
    queryData: {
      deep: true,
      immediate: true,
      handler(e) {
        this.$emit('update:form', e)
      },
    },
    tempRowData: {
      deep: true,
      immediate: true,
      handler(e) {
        this.$emit('update:form', e)
      },
    },
    loading: {
      immediate: true,
      handler(e) {
        if (!e) {
          setTimeout(() => {
            this.setOtherMenuDisplay()
          }, 10)
        }
      },
    },
  },
  created() {
    // 判断menu是否需要渲染
    if (this.option_menu) {
      this.columns.push({
        label: this.i18n('btns.menu'),
        field: '_menu',
        sortable: false,
        width: `${this.option_menuWidth}px`,
      })
    }
  },
  mounted() {},
  methods: {
    // 弹窗关闭前的回调 父组件调用done执行完成
    handleBeforeClose(type) {
      this.formLoading = false
      let isDone = false
      const done = () => {
        if (!isDone) {
          this.sidebarShow[type] = false
          /**
           * 关闭弹框前清空form数据
           */
          this.tempRowData = {}
          isDone = true
        }
      }
      this.beforeClose(done, type)
    },
    // 弹窗提示
    modelPrompt(key, row) {
      if (key === 'batchDelete' && this.getSelectedRows().length <= 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'ERROR',
            icon: 'BellIcon',
            text: this.$t('_components.message.notSelectData'),
            variant: 'danger',
          },
        })
        return
      }
      this.modalShow[key] = true
      if (key === 'columnOption') {
        // 默认选中column
        this.selectedColumns = this.uniqueColumns
          .filter((o) => !o.hide)
          .map((o) => o.key)
      }
      this.tempRowData = row || {}
    },
    // 弹窗打开前的回调 父组件调用done执行完成
    handleBeforeOpen(type, row) {
      this.tempRowData = deepClone(row) || {}
      let isDone = false
      const done = () => {
        if (!isDone) {
          this.sidebarShow[type] = true
          isDone = true
        }
      }
      // if (type === 'add') {
      //   this.tempRowData = {}
      // }
      this.beforeOpen(done, type, this.tempRowData)
    },
    // 获取弹窗标题
    sidebarTitle(key) {
      const defaultLink = '_components.btns.'
      return this.$t(`${defaultLink + key}`) || key
    },
    // 表单提交
    handleSubmit(key, data) {
      console.log(123)
      this.formLoading = true
      const done = () => {
        if (this.formLoading) {
          this.formLoading = false
          this.sidebarShow[key] = false
        }
      }
      this.$emit(`submit-${key}`, done, data)
    },
    handleReset(key, data) {
      this.$emit('reset', data)
    },
    // 搜索按钮
    searchChange(form) {
      this.searchLoading = true
      const done = () => {
        if (this.searchLoading) {
          this.searchLoading = false
        }
      }
      const res = {}
      Object.keys(form).forEach((key) => {
        const item = form[key]
        if (item) {
          res[key] = item
        }
      })
      this.$emit('searchChange', done, res)
    },
    // 弹窗点击confirm按钮
    handleModelConfirm(key, e) {
      this[`handle_${key}`](e)
    },
    // 点击删除
    handle_delete() {
      this.modalShow.delete = false
      this.$emit('rowDel', this.tempRowData)
    },
    // 调用该方法可以获取复选框勾选数据
    getSelectedRows() {
      return this.$refs['gtable-crud'].selectedRows
    },
    // 点击批量删除
    handle_batchDelete() {
      this.modalShow.batchDelete = false
      this.$emit('batchDelete', this.getSelectedRows())
    },
    // 点击下载按钮
    handleDownLoad() {
      this.$emit('download', this.getSelectedRows())
    },
    // 点击上传按钮
    handleUpLoad() {
      this.$emit('upload')
    },
    // 保存列配置
    handle_columnOption(e) {
      const temp = deepClone(this.columns)
      const res = []
      temp.forEach((item) => {
        const t = item
        t.hide = e.indexOf(item.field) === -1
        res.push(t)
      })
      this.columns = res
      this.modalShow.columnOption = false
    },
    // 点击刷新
    handleRefresh() {
      this.$emit('refresh-change')
    },
    // 搜索重置
    searchReset() {
      this.$emit('searchReset')
    },
    // 国际化
    i18n(param) {
      return this.$t(`_components.${param}`)
    },
    // 行单击
    onRowClick(e) {
      this.$emit('onRowClick', e)
    },
    // 行双击
    onRowDoubleClick(e) {
      this.$emit('onRowDoubleClick', e)
    },
    // 单元格单击
    onCellClick(e) {
      this.$emit('onCellClick', e)
    },
    // 鼠标移出
    onRowMouseover(e) {
      this.$emit('onRowMouseover', e)
    },
    // 鼠标移入
    onRowMouseleave(e) {
      this.$emit('onRowMouseleave', e)
    },
    // 控制other menu的显影
    setOtherMenuDisplay() {
      this.$nextTick(() => {
        const dom = document.querySelectorAll('.gtable-crud__dropdown-menuSlot')
        const menuOtherIcon = document.querySelectorAll(
          '.gtable-crud .menuOtherIcon'
        )
        for (let i = 0; i < dom.length; i += 1) {
          const item = dom[i]
          const div = item.getElementsByTagName('div') || []
          menuOtherIcon[i].style.display = 'block'
          if (div.length <= 0) {
            menuOtherIcon[i].style.display = 'none'
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.gtable-crud {
  .custom-col {
    cursor: default;
    width: 100%;
    display: flex;
    /* justify-content: space-between; */
    justify-content: flex-start;
    align-items: center;
    > .menu-slot {
      line-height: 40px;
      /* width: 40px; */
      margin: 0 7px;
      /* margin-bottom: 7px; */
    }
    & > span {
      line-height: 40px;
      /* width: 40px; */
      margin: 0 7px;
      /* margin-bottom: 7px; */
    }
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
.gtable-crud {
  .row-highlight {
    background-color: rgba(123, 112, 241, 0.2);
  }
  .vgt-global-search {
    border: none;
  }
  .vgt-global-search {
    position: relative;
  }
  .ml-0-5 {
    margin-left: 0.5rem !important;
  }
  .mr-0-5 {
    margin-right: 0.5rem !important;
  }
  &__dropdown .btn {
    padding: 0;
  }
  .status-tag {
    width: 12px;
    height: 12px;
    display: inline-block;
    border-radius: 50%;
    margin: 0 7px;
  }
  table td,
  table th {
    vertical-align: middle !important;
  }
  table.vgt-table {
    font-size: 12px;
  }
}
.ant-dropdown {
  background-color: #fff;
  border: 1px solid #eee;
  .menuSlot {
    display: flex;
    flex-flow: column;
    .btn {
      text-align: left;
    }
  }
}
</style>
